import React, { useState } from "react";
import img1 from "../assets/images/ch-3.jpg";
import img2 from "../assets/images/ch-1.jpg";
import img3 from "../assets/images/ch-6.jpg";
import img4 from "../assets/images/ch-5.jpg";
import img5 from "../assets/images/ch-2.jpg";
import img6 from "../assets/images/ch-4.jpg";

const Card = ({ img, icon, id }) => (
  <div className=" w-[100%] hover hover:cursor-pointer sx:w-[200px] sm:w-[250px] h-[215px] sm:h-[215px] rounded-[15px]  lg:m-3 flex gap-1 justify-center items-center text-center">
    <img
      className="rounded-[15px] w-full h-full card-content"
      src={img}
      alt=""
    />
  </div>
);
const Partners2 = () => {
  const [state, setState] = useState("");
  const cards = [
    { img: img1, icon: "📦" },
    { img: img2, icon: "🛒" },
    { img: img3, icon: "💳" },
    { img: img4, icon: "📦" },
    { img: img5, icon: "🛒" },
    { img: img6, icon: "💳" },
  ];
  console.log(state, "index");
  return (
    <>
      {state === 0 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto"
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=0&theme=dark&primaryColor=red"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : state === 1 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto "
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=1&theme=dark&primaryColor=red"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : state === 2 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto "
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=2&theme=dark&primaryColor=red"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : state === 3 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto"
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=3&theme=dark&primaryColor=teal"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : state === 4 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto"
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=4&theme=dark&primaryColor=teal"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : state === 5 ? (
        <div
          class="relative z-10"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

          <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto"
            onClick={() => setState(null)}
          >
            <div class="flex min-h-full justify-center p-4 text-center sm:items-center sm:p-0">
              <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <iframe
                  src="https://embed.ipfscdn.io/ipfs/bafybeigdie2yyiazou7grjowoevmuip6akk33nqb55vrpezqdwfssrxyfy/erc1155.html?contract=0x1bB67adbF8C975C27a4354E84A750F787FFa1A40&chain=%7B%22name%22%3A%22BNB+Smart+Chain+Mainnet%22%2C%22chain%22%3A%22BSC%22%2C%22rpc%22%3A%5B%22https%3A%2F%2Fbinance.rpc.thirdweb.com%2F%24%7BTHIRDWEB_API_KEY%7D%22%5D%2C%22nativeCurrency%22%3A%7B%22name%22%3A%22BNB+Chain+Native+Token%22%2C%22symbol%22%3A%22BNB%22%2C%22decimals%22%3A18%7D%2C%22shortName%22%3A%22bnb%22%2C%22chainId%22%3A56%2C%22testnet%22%3Afalse%2C%22slug%22%3A%22binance%22%2C%22icon%22%3A%7B%22url%22%3A%22ipfs%3A%2F%2FQmcxZHpyJa8T4i63xqjPYrZ6tKrt55tZJpbXcjSDKuKaf9%2Fbinance-coin%2F512.png%22%2C%22width%22%3A512%2C%22height%22%3A512%2C%22format%22%3A%22png%22%7D%7D&clientId=53121ff967dc1cacc701072ed62764a4&tokenId=5&theme=dark&primaryColor=teal"
                  width="600px"
                  height="600px"
                  style={{ maxWidth: "100%" }}
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="flex items-center justify-center text-white mt-[70px] lg:mt-[150px] characters partners_main_div ">
        <div className="red-1 hidden lg:block"></div>
        <div className="red-2 hidden lg:block"></div>
        <div className="text-center">
          <h1 className=" font-bold text-[35px] sm:text-[45px] md:text-[60px] mb-[50px]">
            CHOOSE YOUR CHARACTER
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 px-4">
            {cards.map((card, index) => (
              <a
                key={index}
                onClick={() => setState(index)}
                className="card-link"
                // target="_"
              >
                <Card key={index} img={card.img} icon={card.icon} id={index} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Partners2;
